import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface AgeRestrictionModalProps {
  isOpen: boolean;
}

export function AgeRestrictionModal({ isOpen }: AgeRestrictionModalProps) {
  const [open, setOpen] = useState(isOpen);
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const handleAccept = () => {
    localStorage.setItem("ageConfirmed", "true");
    setOpen(false);
  };

  const handleDecline = () => {
    navigate("/");
  };

  return (
    <>
      {/* Full screen overlay to block gallery content */}
      {open && (
        <div
          className="fixed inset-0 z-[100]"
          style={{
            backgroundColor: "hsl(var(--deep-black))",
          }}
        />
      )}

      <Dialog open={open} onOpenChange={(value) => !value && navigate("/")}>
        <DialogContent
          className="max-w-md border-2 z-[101]"
          style={{
            backgroundColor: "hsl(var(--deep-black))",
            borderColor: "hsl(var(--gold))",
            boxShadow: "0 0 40px hsl(var(--gold) / 0.4), 0 0 80px hsl(var(--gold) / 0.2)",
          }}
        >
          <DialogHeader className="space-y-4">
            <div className="flex justify-center">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center animate-pulse-glow"
                style={{
                  backgroundColor: "hsl(var(--gold) / 0.2)",
                }}
              >
                <AlertTriangle className="w-8 h-8" style={{ color: "hsl(var(--gold))" }} />
              </div>
            </div>

            <DialogTitle className="text-2xl font-bold text-center" style={{ color: "hsl(var(--gold))" }}>
              Age Restriction
            </DialogTitle>

            <DialogDescription className="text-base leading-relaxed text-center space-y-4">
              <p style={{ color: "hsl(var(--foreground) / 0.9)" }}>
                This site contains age-restricted material, including nudity and explicit depictions of sexual activity
                generated by AI
              </p>
              <p style={{ color: "hsl(var(--foreground) / 0.9)" }}>
                By accessing, you confirm that you are at least 18 years old or of legal age in your jurisdiction.
                accessing the site and consent to view sexually explicit content.
              </p>
            </DialogDescription>
          </DialogHeader>

          <div className="flex flex-col gap-3 mt-6">
            <Button
              onClick={handleAccept}
              className="w-full text-base font-semibold hover-glow-gold"
              style={{
                background: "linear-gradient(135deg, hsl(var(--gold)), hsl(var(--gold-light)))",
                color: "hsl(var(--deep-black))",
              }}
            >
              I am 18+ years old - Continue
            </Button>

            <Button
              onClick={handleDecline}
              variant="outline"
              className="w-full text-base hover:bg-muted/50"
              style={{
                borderColor: "hsl(var(--gold) / 0.5)",
                color: "hsl(var(--foreground))",
              }}
            >
              Log Out
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
